/* @flow */
import enumerate from 'lib/enumerate';

export const ActionTypes = enumerate([
  'JOIN_CLASS_FOR_SETUP_SESSION',
  'REMOVE_FLAGS_FOR_SETUP_SESSION',
]);



// WEBPACK FOOTER //
// ./src/constants/SetupConstants.js